
import React from 'react'

import { Box, Grid, Step } from '@mui/material'
import { GridStepper } from '@front/squirtle'

import Dialogs from './Popup'
import {
  AdherentsSection,
  ConnectionSection,
  CustomerBlacklistSection,
  HeatmapBlacklist,
  HistorySection,
  OptionsSection,
  PrimarySection,
  SecondarySection,
  ServiceBlacklistSection
} from './Section'

import LoginSection from '@abra/frames/LoginSection'
import FormHeader, { Title } from '@abra/elements/headers/Form'
import FormSpeedDial from '@abra/elements/speedDial/Form'
import GroupTab from '@abra/panels/Tab/Group'

import TitleComponent from './Title'

const Driver = ({ isManagingRecord, group_id, actions, handleCall }) => (
  <>
    <Dialogs handleCall={handleCall} />
    <Box sx={{ display: 'flex', justifyContent: 'center' }} px={6}>
      <Grid container rowSpacing={4}>
        <Grid hidden={!group_id} size={12}><GroupTab value={4} /></Grid>
        <Grid size={12}>
          <FormHeader labelKey={'driver'}>
            <Title><TitleComponent /></Title>
          </FormHeader>
        </Grid>
        <Grid size={12}>
          <GridStepper groupsCount={[9]} activeStep={0} orientation={'vertical'}>
            <Step><PrimarySection /></Step>
            <Step display='flex'>
              <LoginSection />
              <ConnectionSection />
            </Step>
            <Step><SecondarySection /></Step>
            <Step><OptionsSection /></Step>
            <Step><HeatmapBlacklist /></Step>
            <Step>{!!isManagingRecord && <CustomerBlacklistSection />}</Step>
            <Step>{!!isManagingRecord && <ServiceBlacklistSection />}</Step>
            <Step><AdherentsSection /></Step>
            <Step>{!!isManagingRecord && <HistorySection />}</Step>
          </GridStepper>
        </Grid>
      </Grid>
    </Box>
    <FormSpeedDial actions={actions} />
  </>
)

export default React.memo(Driver)
